import styled, { css } from "styled-components";

import { colorsPalettes, rgba } from "@similarweb/styles";
import type { StrictColor } from "@similarweb/styles";
import { Box } from "@similarweb/ui-components";

import { CenteredFlexColumn } from "pro-features/styled components/StyledFlex/src/StyledFlex";

const WidgetBox = styled(Box).attrs({
    width: "100%",
    height: "initial",
})<{ wide?: boolean }>`
    ${({ wide }) => wide && `grid-column: span 2`};
`;

export const WidgetBoxWithMarginBottom = styled(WidgetBox)`
    margin-bottom: 24px;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    overflow: hidden;
`;

export const Overlay = styled(CenteredFlexColumn)<{ $isHidden?: boolean }>`
    ${($isHidden) =>
        $isHidden
            ? css`
                  display: none;
              `
            : css`
                  position: absolute;
              `}
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
    background: ${rgba(colorsPalettes.carbon[0], 0.4)};
    backdrop-filter: blur(10px);
`;

export const OverlayContent = styled(CenteredFlexColumn)`
    white-space: normal;
    padding: 16px;
    gap: 16px;
    width: 100%;
    text-align: center;
`;

export const BottomBorderHider = styled.div`
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 1px;
    background-color: ${colorsPalettes.carbon[0]};
    z-index: 1;
`;

export const ColorCircle = styled.div.withConfig({
    componentId: "AdIntel-ColorCircle",
})<{ color: StrictColor }>`
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: ${({ color }) => color};
    flex-shrink: 0;
`;
